import styled from 'styled-components';
import { elevation } from '../Styles/Utils/elevation.js';

const Container = styled.div.withConfig({
    displayName: "styled__Container",
    componentId: "sc-5f5ef31c-0"
})`
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: fixed;
    z-index: 3;
    overflow-y: auto;
    ${elevation(3, false)}
`;
const Shadow = styled.div.withConfig({
    displayName: "styled__Shadow",
    componentId: "sc-5f5ef31c-1"
})`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    pointer-events: none;
    background-color: rgba(0, 0, 0, 0.8);
`;
const HeaderWrapper = styled.div.withConfig({
    displayName: "styled__HeaderWrapper",
    componentId: "sc-5f5ef31c-2"
})`
    position: relative;
`;
const Content = styled.div.withConfig({
    displayName: "styled__Content",
    componentId: "sc-5f5ef31c-3"
})`
    position: relative;
    overflow-y: auto;
`;

export { Container, Content, HeaderWrapper, Shadow };
